import { MobileContentGems } from '@mc/api'
import { Tile, TileCaption, TileImage } from '@mc/design-system'

type StickyCardDesktopProps = {
  gem: MobileContentGems
  index: number
}

export const StickyCardDesktop = ({ gem, index }: StickyCardDesktopProps) => (
  <div className='col-sm-6 col-lg-3'>
    <div className='mc-p-2'>
      <Tile
        aspectRatio='auto'
        className='mc-corners--md mc-overflow--hidden'
        style={{
          aspectRatio: '51/64',
        }}
      >
        <TileCaption position='left top' padding={4}>
          <div
            className='mc-bg-primary mc-corners--circle d-flex align-items-center justify-content-center'
            style={{
              width: 35,
              height: 35,
            }}
          >
            {index + 1}
          </div>
        </TileCaption>

        <TileImage imageUrl={gem.imageUrl} alt='' />

        <TileCaption position='center bottom' padding={4}>
          <span className='mc-text-h5'>{gem.title}</span>
        </TileCaption>
      </Tile>
    </div>
  </div>
)
